import { CSSObject } from '@mui/material/styles';

type ScrollbarDirection = 'vertical' | 'horizontal' | 'both';

export type ScrollbarOptions = {
	visible?: boolean;
	direction?: ScrollbarDirection;
	size?: string;
	color?: string;
};

export const scrollbar = ({
	visible = false,
	direction = 'vertical',
	size = '6px',
	color = 'var(--scrollbar_color)',
}: ScrollbarOptions = {}): CSSObject => {
	const overflow: CSSObject = {};

	switch (direction) {
		case 'horizontal':
			overflow.overflowY = 'hidden';
			overflow.overflowX = 'overlay' as any;
			break;
		case 'both':
			overflow.overflowY = 'overlay' as any;
			overflow.overflowX = 'overlay' as any;
			break;
		case 'vertical':
		default:
			overflow.overflowY = 'overlay' as any;
			overflow.overflowX = 'hidden';
	}

	const thumbColor = visible ? color : 'transparent';

	return {
		...overflow,
		'&::-webkit-scrollbar': {
			borderRadius: 0,
			width: size,
			height: size,
		},
		'&:hover::-webkit-scrollbar': {
			backgroundColor: 'transparent',
		},
		'&::-webkit-scrollbar-corner': {
			background: 'transparent',
			borderColor: 'transparent',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: thumbColor,
			borderRadius: `calc(${size} * 0.5)`,
		},
		'&:hover::-webkit-scrollbar-thumb': {
			backgroundColor: color,
			backgroundClip: 'padding-box',
		},
	};
};
